import { Component, Inject, OnInit } from '@angular/core';
import { DialogBase } from 't4core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-travel-range',
  templateUrl: './travel-range.component.html',
  styleUrls: ['./travel-range.component.css'],
  standalone: false
})
export class TravelRangeDialog extends DialogBase implements OnInit {
  public form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<TravelRangeDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super('TravelRangeDialog');
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      range: [null, Validators.required]
    });
  }

  public confirmTravelRange(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const value = this.form.get('range')?.value;
    this.dialogRef.close(value);
  }

  public cancelTravelRange(): void {
    this.dialogRef.close();
  }
}
